import { FlexRow } from '@/components/common/Flex';
import { Circle, Text } from '@chakra-ui/react';
import { useTags } from '@common/react/cashflow';
import { useMemo } from 'react';

const useTagOptions = () => {
    const { tags } = useTags();

    return useMemo(
        () =>
            tags.map((tag) => ({
                label: (
                    <FlexRow align="center" gap={2}>
                        <Circle size={3} bg={tag.color} />
                        <Text>{tag.name}</Text>
                    </FlexRow>
                ),
                value: tag.name,
            })),
        [tags]
    );
};

export default useTagOptions;
